/**************************************************
 * Nombre:       Footer
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import logo from '../../Recursos/logo_completo.svg'
import {GRADIENTE, SECCIONES, URLUSUARIO} from "../../Constantes";
import {useEffect, useState} from "react";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {scrolearAComponente} from "../../Utilidades/scrolearAComponente";
import {useNavigate} from "react-router-dom";
import {irUrl} from "../../Utilidades/irUrl";

const Footer = () => {
    const {sCell} = useResponsive()
    const navigate = useNavigate();
    const [capacitaciones, setCapacitaciones] = useState([]);

    const irRuta = (secc) => {

        switch (secc) {
            case SECCIONES[1]:
                navigate('/Testimonios');
                break
            case SECCIONES[0]:
                navigate('/Home')
                setTimeout(() => {
                    scrolearAComponente('sistema')
                }, 500)
                break
            case SECCIONES[2]:
                navigate('/Home')
                setTimeout(() => {
                    scrolearAComponente('calendario')
                }, 500)
                break
        }

    }

    useEffect(() => {
        let w = [where('estado', '==', 'Publicado')]
        obtenerColWheres({col: 'capacitaciones', wheres: w}).then((dox) => {
            setCapacitaciones(dox.data);
        })
    }, [])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: '#FFF',
                boxShadow: '0 4px 50px 0 rgba(133, 49, 253, 0.20)'
            }}

        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, py: 6}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={2}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={0}
                            >

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 1.5}}>
                                    <img src={logo} width={200} height={'auto'}/>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: sCell ? 1 : 2}}>
                                    <Typography sx={{
                                        color: '#262626',
                                        fontSize: sCell ? 18 : 20,
                                        fontWeight: 600,
                                        lineHeight: 1.1
                                    }}>Sistema
                                        de
                                        formación de emprendedores </Typography>
                                </Grid>

                                {sCell &&
                                    <Grid container size={{xs: 3, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>

                                    </Grid>
                                }

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: sCell ? 1 : 1}}>
                                    <Typography sx={{color: '#545454', fontSize: sCell ? 12 : 14, fontWeight: 300}}>Emprender
                                        no se
                                        trata solo de dinero, sino de alcanzar las metas que realmente importan:
                                        libertad, tiempo, propósito y realización personal.</Typography>
                                </Grid>

                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 3}}
                              sx={{justifyContent: 'flex-start', mt: sCell ? 1 : 0}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={0}
                            >


                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 2}}>
                                    <Typography sx={{color: '#262626', fontSize: 18, fontWeight: 700, lineHeight: 1.1}}>
                                        Links Rapidos</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 2}}>
                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}
                                        spacing={1}
                                    >

                                        {SECCIONES.map((item, i) => (
                                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                  sx={{justifyContent: 'flex-start', mt: -0.5}}>
                                                <Typography
                                                    onClick={() => irRuta(item)}
                                                    sx={{
                                                        transition: "all .2s ease-in-out",
                                                        fontWeight: 500,
                                                        borderBottom: 2,
                                                        borderColor: '#00000000',
                                                        cursor: 'pointer',
                                                        '&:hover': {
                                                            borderColor: '#000',
                                                        }
                                                    }}
                                                >
                                                    {item}</Typography>
                                            </Grid>
                                        ))}


                                    </Grid>
                                </Grid>


                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={0}
                            >


                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 2}}>
                                    <Typography sx={{color: '#262626', fontSize: 18, fontWeight: 700, lineHeight: 1.1}}>
                                        Ultimas capacitaciones
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 2}}>
                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}
                                        spacing={1}
                                    >

                                        {capacitaciones.map((item, i) => (
                                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                  sx={{justifyContent: 'flex-start', mt: -0.5}}>
                                                <Typography
                                                    sx={{

                                                        transition: "all .2s ease-in-out",
                                                        fontWeight: 500,
                                                        borderBottom: 2,
                                                        borderColor: '#00000000',
                                                        cursor: 'pointer',
                                                        '&:hover': {
                                                            borderColor: '#000',
                                                        }
                                                    }}>{item.nombre}</Typography>
                                            </Grid>
                                        ))}


                                    </Grid>
                                </Grid>


                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 2}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={0}
                            >


                                <Grid container size={{xs: 6, sm: 12, md: 12}}
                                      sx={{justifyContent: 'center', mt: sCell ? 4 : 8}}>
                                    <Button
                                        onClick={() => irUrl(URLUSUARIO + 'registro')}
                                        variant={'outlined'} sx={{px: 6}}>Registro</Button>
                                </Grid>

                                <Grid container size={{xs: 6, sm: 12, md: 12}}
                                      sx={{justifyContent: 'center', mt: sCell ? 4 : 2}}>
                                    <Button
                                        onClick={() => irUrl(URLUSUARIO + 'ingreso')}
                                        sx={{px: 6, background: GRADIENTE}}>Ingresar</Button>
                                </Grid>


                            </Grid>
                        </Grid>

                    </Grid>

                </Grid>


            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Typography sx={{textAlign: 'center', color: '#000',p: 2}}>
                    © Copyright 2025 - 2026 | Sistema Team Tufiño
                </Typography>
            </Grid>

        </Grid>
    )

}
export default Footer    